<template lang="pug">
.container.grid-lg.py-2
  .no-print
    form-filter(
      @submit="onFilter",
      :auto-filter="autoFilter",
      :default-query="q",
      filter-key="doc-detalhados-filters"
    )

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      table.table.table-striped.table-sm
        thead
          tr
            th {{ "doc.numero" | tModel }}/{{ "doc.ano" | tModel }}
            th {{ "doc.modelo" | tModel }}
            th.text-right Área
            th.text-right {{ "doc.valor_total" | tModel }}
            th {{ "doc.reincidente" | tModel }}
            th {{ "doc.cadastro" | tModel }}
            th {{ "pessoa.cpf_cnpj" | tModel }}
            th {{ "pessoa.razao_social" | tModel }}
            th {{ "doc.local" | tModel }}
            th {{ "doc.created_at" | tModel }}
            th {{ "doc.ciencia_em" | tModel }}
            th {{ "doc.situacao" | tModel }}
            th {{ "doc.fiscal" | tModel }}
            th Dias vencido
            th.actions-col.no-print
        tbody
          tr(v-for="doc in list")
            td {{ doc.numero }}/{{ doc.ano }}
            td {{ doc.modelo ? doc.modelo.descricao : "-" }}
            td.text-right
              span(v-if="doc.area") {{ doc.area | currency }}
            td.text-right {{ doc.valor_total | currency }}
            td.text-center {{ doc.reincidente ? `${doc.reincidente}ª` : "" }}
            td
              small
                span.abbr {{ doc.cadastro | enums("cadastro.tipo") }}
              span {{ doc.cadastro.numero }}
            td
              span(v-if="doc.cadastro && doc.cadastro.contribuinte") {{ doc.cadastro.contribuinte.cpf_cnpj | cpfCnpj }}
              span(v-else) -
            td
              span(v-if="doc.cadastro && doc.cadastro.contribuinte") {{ doc.cadastro.contribuinte.razao_social }}
              span(v-else) -
            td
              span(v-if="doc.local && doc.local.cadastro") {{ doc.local.cadastro.endereco_formatado }}
              span(v-else) -
            td {{ doc.created_at | date }}
            td {{ doc.ciencia_em | date }}
            td {{ doc.situacao ? doc.situacao.descricao : "-" }}
            td {{ doc.fiscal ? doc.fiscal.nome : "-" }}
            td {{ doc.dias_vencido_regularizar }}
            td.actions-col.no-print
              router-link.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                data-tooltip="Exibir",
                :to="{ name: 'fiscalizacao.docs.show', params: { id: doc.id } }"
              )
                i.fa.fa-eye
        tfoot
          tr
            th(colspan="3") Total
            th.text-right {{ totais.valor_total | currency }}
            th.text-right {{ totais.q }}
            th(colspan="99")
      .my-2.text-right(v-if="pages > 1")
        btn-paginate(
          :page="page",
          :pages="pages",
          :count="count",
          @go-page="goPage",
          @prev-page="prevPage",
          @next-page="nextPage"
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FormFilter from "../docs/components/Filter"

export default {
  vuex: {
    "fiscalizacao/docDetalhados": vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return { q: { id_order_by: "desc", ano_eq: new Date().getFullYear() } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.listar()
    },
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
